module.exports = __webpack_public_path__ + "static/media/google-play-id.b62b034f.png";